import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Button from 'brandComponents/Button';

import messages from '../../messages';

import {IOrderDetailsTopSectionProps} from './IOrderDetailsTopSection';

const OrderDetailsTopSection = ({
	classNames,
	productsNumber,
	isReturnable,
	trackingUrl,
	handleReturnOrder,
	returnLink,
}: IOrderDetailsTopSectionProps) => {
	const intl = useIntl();

	const totalItemsMessage = useMemo(() => {
		return productsNumber > 1
			? intl.formatMessage(messages.youPurchasedItems, {items: productsNumber})
			: intl.formatMessage(messages.youPurchasedItem);
	}, []);

	const renderReturnButton = () => {
		if (!isReturnable) {
			return null;
		}

		if (returnLink) {
			return (
				<a href={returnLink} target="_blank" rel="noreferrer">
					<Button variant="primary-white" fixed>
						{intl.formatMessage(messages.requestReturn)}
					</Button>
				</a>
			);
		}

		return (
			<Button url="/return" variant="primary-white" fixed onClick={handleReturnOrder}>
				{intl.formatMessage(messages.requestReturn)}
			</Button>
		);
	};

	return (
		<div className={cn(classNames.wrap, 'order-details__top-section')}>
			<span>{totalItemsMessage}</span>
			<div className={cn(classNames.buttonWrap, 'order-details__top-section__button-wrapper')}>
				{renderReturnButton()}
				{trackingUrl && (
					<Button url={trackingUrl} target="_blank" variant="primary" fixed>
						{intl.formatMessage(messages.trackOrder)}
					</Button>
				)}
			</div>
		</div>
	);
};

export default OrderDetailsTopSection;
